import { Routes } from '@angular/router';
export const rhgRoutes: Routes = [
    {
        path: 'dashboard/index',
        title: 'Pulse - Home',
        loadComponent: () =>
            import('app/clients/rhg/dashboards/index/index.component').then(
                m => m.IndexComponent
            ),
    },
    {
        path: 'dashboard/docs',
        title: 'Pulse - Docs',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/docs/docs.component').then(
                m => m.DocsComponent
            ),
    },
    {
        path: 'dashboard/forum',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forum/forum.component').then(
                m => m.ForumComponent
            ),
    },
    {
        path: 'dashboard/leaderboard',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/leaderboard/leaderboard.component').then(
                m => m.LeaderboardComponent
            ),
    },
    {
        path: 'dashboard/achievments',
        loadComponent: (): any =>
            import('app/main/dashboard-header-nav/achievements/achievements.view.component').then(
                m => m.AchievementsViewComponent
            ),
    },
    {
        path: 'dashboard/daily-digest',
        title: 'Pulse - Daily Digest',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/daily-digest/daily-digest.component').then(
                m => m.DailyDigestComponent
            ),
    },
    {
        path: 'dashboard/radisson-academy',
        title: 'Radisson Academy',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/radisson-academy/radisson-academy.component').then(
                m => m.RadissonAcademyComponent
            ),
    },
    {
        path: 'dashboard/mobile-app-docs',
        title: 'Mobile App Docs',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/mobile-app-docs/mobile-app-docs.component').then(
                m => m.MobileAppDocsComponent
            ),
    },
    {
        path: 'dashboard/million-video-docs',
        title: '1M Video Docs',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/million-video-docs/million-video-docs.component').then(
                m => m.MillionVideoDocsComponent
            ),
    },
    // Revops dashboards
    {
        path: 'dashboard/pace-report',
        title: 'Pace Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/pace-report/pace-report.component').then(
                m => m.PaceReportComponent
            ),
    },
    {
        path: 'dashboard/rhg-marketshare',
        title: 'Market Share',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/rhg-marketshare/rhg-marketshare.component').then(
                m => m.RhgMarketshareComponent
            ),
    },
    {
        path: 'dashboard/forecast-accuracy',
        title: 'Forecast Accuracy',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/forecast-accuracy/forecast-accuracy.component').then(
                m => m.ForecastAccuracyComponent
            ),
    },
    {
        path: 'dashboard/room-type',
        title: 'Room Type',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/room-type/room-type.component').then(
                m => m.RoomTypeComponent
            ),
    },
    {
        path: 'dashboard/system-contribution2',
        title: 'System Contribution',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/system-contribution2/system-contribution2.component').then(
                m => m.SystemContribution2Component
            ),
    },
    {
        path: 'dashboard/commercial-report',
        title: 'Brand & Marketing Performance',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/commercial-report/commercial-report.component').then(
                m => m.CommercialReportComponent
            ),
    },
    {
        path: 'dashboard/system-contribution-models',
        title: 'System Contribution Models',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/system-contribution-models/system-contribution-models.component').then(
                m => m.SystemContributionModelsComponent
            ),
    },
    {
        path: 'dashboard/channel-mix',
        title: 'Channel Mix',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/channel-mix/channel-mix.component').then(
                m => m.ChannelMixComponent
            ),
    },
    {
        path: 'dashboard/segment-mix',
        title: 'Segment Mix',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/segment-mix/segment-mix.component').then(
                m => m.SegmentMixComponent
            ),
    },
    {
        path: 'dashboard/feeder-market',
        title: 'Feeder Market',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/feeder-market/feeder-market.component').then(
                m => m.FeederMarketComponent
            ),
    },
    {
        path: 'dashboard/cost-acquisition',
        title: 'Cost Acquisition',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/cost-acquisition/cost-acquisition.component').then(
                m => m.CostAcquisitionComponent
            ),
    },
    {
        path: 'dashboard/fc-evo',
        title: 'Forecast Evolution',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/forecast-evolution/forecast-evolution.component').then(
                m => m.FcEvoComponent
            ),
    },
    {
        path: 'dashboard/fc-evo-V2',
        title: 'Forecast Evolution Manuelito',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/forecast-evolution-V2/forecast-evolution-V2.component').then(
                m => m.FcEvoV2Component
            ),
    },
    {
        path: 'dashboard/ota-v2',
        title: 'Rate Shopper',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/ota_v2/ota_v2.component').then(
                m => m.OtaV2Component
            ),
    },
    {
        path: 'dashboard/pickup',
        title: 'Pickup',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/pickup/pickup.component').then(
                m => m.PickupComponent
            ),
    },
    {
        path: 'dashboard/agency-360',
        title: 'Agency 360',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/agency-360/agency-360.component').then(
                m => m.Agency360Component
            ),
    },
    {
        path: 'dashboard/brand-com',
        title: 'Brand Web Analytics',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/brand-com/brand-com.component').then(
                m => m.BrandComComponent
            ),
    },
    {
        path: 'dashboard/campaign-promotion-overview',
        title: 'Campaign Promotion Overview',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/campaign-promotion/campaign-promotion.component').then(
                m => m.CampaignPromotionComponent
            ),
    },
    {
        path: 'dashboard/pulse-pivot-v2',
        title: 'Pulse Pivot',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/pivot2/pulse-pivot.page').then(
                m => m.PulsePivotPage
            ),
    },
    {
        path: 'dashboard/owner-executive',
        title: 'Owner Executive',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/owner-executive/owner-executive.component').then(
                m => m.OwnerExecutiveComponent
            ),
    },

    {
        path: 'dashboard/corporate-pickup',
        title: 'Corporate Pickup',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/corporate-pickup/corporate-pickup.component').then(
                m => m.CorporatePickupComponent
            ),
    },
    {
        path: 'dashboard/events-calendar',
        title: 'Events Calendar',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/events/events.component').then(
                m => m.EventsDashboardComponent
            ),
    },
    // Distribution dashboards
    {
        path: 'dashboard/demand-360',
        title: 'Demand 360',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/distribution/demand-360/demand-360.component').then(
                m => m.Demand360Component
            ),
    },
    // S&M dashboards
    {
        path: 'dashboard/sales-production',
        title: 'Sales Production',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/sales-production/sales-production.component').then(
                m => m.SalesProductionComponent
            ),
    },
    {
        path: 'dashboard/sp-executive',
        title: 'SP Executive',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/sp-executive/sp-executive.component').then(
                m => m.SPExecutiveComponent
            ),
    },
    {
        path: 'dashboard/sp-executive-v2',
        title: 'SP Executive V2',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/sp-executive-V2/sp-executive-V2.component').then(
                m => m.SPExecutiveV2Component
            ),
    },
    {
        path: 'dashboard/me-intel',
        title: 'M&E Intel',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-intel/me-intel.component').then(
                m => m.MEIntelComponent
            ),
    },
    {
        path: 'dashboard/me-leads',
        title: 'M&E Leads',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-leads/me-leads.component').then(
                m => m.MELeadsComponent
            ),
    },
    {
        path: 'dashboard/me-space',
        title: 'M&E Space',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-space/me-space.component').then(
                m => m.MESpaceComponent
            ),
    },
    {
        path: 'dashboard/me-connectivity',
        title: 'M&E Connectivity',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-connectivity/me-connectivity.component').then(
                m => m.MEConnectivityComponent
            ),
    },
    {
        path: 'dashboard/me-demand',
        title: 'M&E Demand',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-demand/me-demand.component').then(
                m => m.MEDemandComponent
            ),
    },
    {
        path: 'dashboard/me-cxl',
        title: 'M&E Lost Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-cxl/me-cxl.component').then(
                m => m.MECxlComponent
            ),
    },
    {
        path: 'dashboard/account-portfolio',
        title: 'Account Portfolio',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/account-portfolio/account-portfolio.component').then(
                m => m.AccountPortfolioComponent
            ),
    },
    {
        path: 'dashboard/industry-report',
        title: 'Industry Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/industry-report/industry-report.component').then(
                m => m.IndustryReportComponent
            ),
    },
    {
        path: 'dashboard/account-manager',
        title: 'Account Manager',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/account-manager/account-manager.component').then(
                m => m.AccountManagerComponent
            ),
    },
    {
        path: 'dashboard/me-productivity',
        title: 'M&E Productivity',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/sales-meetings/me-productivity/me-productivity.component').then(
                m => m.MeProductivityComponent
            ),
    },
    {
        path: 'dashboard/rate-code-production',
        title: 'Rate Code Production',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/rate-code-production/rate-code-production.component').then(
                m => m.RateCodeComponent
            ),
    },
    // Operations dashboards
    {
        path: 'dashboard/operational-report',
        title: 'Operational Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/finance/operational-report/operational-report.component').then(
                m => m.OperationalReportComponent
            ),
    },
    {
        path: 'dashboard/operational-report-lhg',
        title: 'Operational Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/finance/operational-report-lhg/operational-report-lhg.component').then(
                m => m.OperationalReportLhgComponent
            ),
    },
    {
        path: 'dashboard/quality-report',
        title: 'Quality Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/operations/quality-report/quality-report.component').then(
                m => m.QualityReportComponent
            ),
    },
    {
        path: 'dashboard/quality-report-lhg',
        title: 'LHG Quality Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/operations/quality-report-lhg/quality-report-lhg.component').then(
                m => m.QualityReportLhgComponent
            ),
    },
    {
        path: 'dashboard/quality-review-pro',
        title: 'Quality Report',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/operations/quality-review-pro/quality-review-pro.component').then(
                m => m.QualityReviewProComponent
            ),
    },
    {
        path: 'dashboard/loyalty',
        title: 'Loyalty',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/operations/loyalty/loyalty.component').then(
                m => m.LoyaltyComponent
            ),
    },
    // Presentations dashboards
    {
        path: 'dashboard/revco_v2',
        title: 'RevCo',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/revco2/revco2.component').then(
                m => m.RevCo2Component
            ),
    },
    {
        path: 'dashboard/area_performance',
        title: 'Area Performance',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/area-performance/area-performance.component').then(
                m => m.AreaPerformanceComponent
            ),
    },
    {
        path: 'dashboard/revgen',
        title: 'RevGen',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/revgen/revgen.component').then(
                m => m.RevGenComponent
            ),
    },
    {
        path: 'dashboard/commercial_review',
        title: 'Commercial Review',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/commercial-review/commercial-review.component').then(
                m => m.CommercialReviewComponent
            ),
    },
    {
        path: 'dashboard/commercial_review_me',
        title: 'Commercial Review M&E',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/commercial-review-me/commercial-review-me.component').then(
                m => m.CommercialReviewMeComponent
            ),
    },
    {
        path: 'dashboard/revgen-lhg',
        title: 'RevGen',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/revgenlhg/revgenlhg.component').then(
                m => m.RevGenLhgComponent
            ),
    },
    {
        path: 'dashboard/account-review',
        title: 'Account Review',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/presentations/account-review/account-review.component').then(
                m => m.AccountReviewComponent
            ),
    },

    // Data Status Dashboard
    {
        path: 'dashboard/import-control',
        title: 'Import Control',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/data-control/import-control/import-control.component').then(
                m => m.ImportControlComponent
            ),
    },
    {
        path: 'dashboard/account-check',
        title: 'Account Check',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/data-control/account-check/account-check.component').then(
                m => m.AccountCheckComponent
            ),
    },
    {
        path: 'dashboard/productivity-home-page-v2',
        title: 'Home Page',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-home-page-v2/prod-home-page-v2.component').then(
                m => m.ProductivityHomePageV2Component
            ),
    },
    {
        path: 'dashboard/productivity-insights',
        title: 'Leadership Insights',
        loadChildren: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-insights/prod-insights.module').then(
                m => m.ProductivityInsightsModule
            ),
    },
    {
        path: 'dashboard/productivity-gop',
        title: 'Forecasted GOP',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-gop/prod-gop.component').then(
                m => m.ProductivityGopComponent
            ),
    },
    {
        path: 'dashboard/productivity-cockpit-v2',
        title: 'Cockpit',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-cockpit-v2/prod-cockpit-v2.component').then(
                m => m.ProductivityCockpitComponentV2
            ),
    },
    {
        path: 'dashboard/productivity-finance',
        title: 'Finance Control',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-finance/prod-finance.component').then(
                m => m.ProductivityFinanceComponent
            ),
    },
    {
        path: 'dashboard/productivity-global-mapping',
        title: 'Global Mapping',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/productivity-global-mapping/productivity-global-mapping.component').then(
                m => m.ProductivityGlobalMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/productivity-settings',
        title: 'Settings',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-settings/prod-settings.component').then(
                m => m.ProductivityCockpitSettingsDashboardComponent
            ),
    },
    {
        path: 'dashboard/productivity-targets-v2',
        title: 'Targets',
        loadChildren: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-cockpit-targets/prod-cockpit-targets.module').then(
                m => m.ProductivityCockpitTargetsModule
            ),
    },
    {
        path: 'dashboard/productivity-benchmark-v2',
        title: 'Benchmark',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-benchmark-v2/prod-benchmark-v2.component').then(
                m => m.ProductivityBenchmarkComponentV2
            ),
    },
    {
        path: 'dashboard/rate-controller-single',
        title: 'Rate Controller',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/rate-controller/rc-single/rc-single.component').then(
                m => m.OrmaDashboardComponent
            ),
    },
    {
        path: 'dashboard/rate-controller-corp',
        title: 'Rate Controller - Corporate View',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/rate-controller/rc-corp/rc-corp.component').then(
                m => m.RCCorpComponent
            ),
    },
    // Displacement Tool
    {
        path: 'dashboard/displacement-tool',
        title: 'Pulse Shift',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/displacement/displacement-tool/displacement-tool.component').then(
                m => m.DisplacementToolComponent
            ),
    },
    {
        path: 'dashboard/displacement-config',
        title: 'Pulse Shift Config',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/displacement/displacement-config/displacement-config.component').then(
                m => m.DisplacementConfigComponent
            ),
    },
    // Simple TKS
    {
        path: 'dashboard/simple-tks',
        title: 'Simple TKS',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/simple-tks/simple-tks.component').then(
                m => m.SimpleTksComponent
            ),
    },
    // Account Negotiation Tool
    {
        path: 'dashboard/wishwantwalk-hotel',
        title: 'Pulse ANT',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/account-negotiation/wishwantwalk-hotel/wishwantwalk-hotel.component').then(
                m => m.WishWantWalkHotelComponent
            ),
    },
    {
        path: 'dashboard/wishwantwalk-sales',
        title: 'Pulse ANT',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/account-negotiation/wishwantwalk-sales/wishwantwalk-sales.component').then(
                m => m.WishWantWalkSalesComponent
            ),
    },
    // Commercial Plan
    {
        path: 'dashboard/cp-overview',
        title: 'Commercial Plan Overview',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/overview/cp-overview.component').then(
                m => m.CommercialPlanOverviewComponent
            ),
    },
    {
        path: 'dashboard/cp-activity-plan',
        title: 'Commercial Plan Activity Plan',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/activity-plan/cp-activity-plan.component').then(
                m => m.CommercialPlanActivityPlanComponent
            ),
    },
    {
        path: 'dashboard/cp-corporate',
        title: 'Commercial Plan Corporate',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/corporate/cp-corporate.component').then(
                m => m.CommercialPlanCorporateComponent
            ),
    },
    {
        path: 'dashboard/cp-tmc',
        title: 'Commercial Plan TMC',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/tmc/cp-tmc.component').then(
                m => m.CommercialPlanTmcComponent
            ),
    },
    {
        path: 'dashboard/cp-bgr',
        title: 'Commercial Plan BGR',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/bgr/cp-bgr.component').then(
                m => m.CommercialPlanBgrComponent
            ),
    },
    {
        path: 'dashboard/cp-me',
        title: 'Commercial Plan M&E',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/me/cp-me.component').then(
                m => m.CommercialPlanMeComponent
            ),
    },
    {
        path: 'dashboard/cp-bgo',
        title: 'Commercial Plan BGO',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/bgo/cp-bgo.component').then(
                m => m.CommercialPlanBgoComponent
            ),
    },
    {
        path: 'dashboard/cp-lgr',
        title: 'Commercial Plan LGR',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/lgr/cp-lgr.component').then(
                m => m.CommercialPlanLgrComponent
            ),
    },
    {
        path: 'dashboard/cp-crew',
        title: 'Commercial Plan CREW',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/commercial-plan/crew/cp-crew.component').then(
                m => m.CommercialPlanCrewComponent
            ),
    },
    {
        path: 'dashboard/one-pager',
        title: 'One Pager',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/score-cards/one-pager/one-pager.component').then(
                m => m.OnePagerComponent
            ),
    },
    {
        path: 'dashboard/hygiene-factors',
        title: 'Hygiene Factors',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/score-cards/score-card/score-card.component').then(
                m => m.ScoreCardComponent
            ),
    },
    {
        path: 'dashboard/rooms-planning',
        title: 'Rooms Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/rooms-planning/rooms-planning.component').then(
                m => m.RoomsPlanningDashboardComponent
            ),
    },
    // upselling
    {
        path: 'dashboard/fd-planning',
        title: 'F&D Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/fd-planning/fd-planning.component').then(
                m => m.FDPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/me-planning',
        title: 'M&E Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/me-planning/me-planning.component').then(
                m => m.MEPlanningDashboardComponent
            ),
    },

    {
        path: 'dashboard/mod-planning',
        title: 'MOD Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/mod-planning/mod-planning.component').then(
                m => m.MODPlanningDashboardComponent
            ),
    },

    {
        path: 'dashboard/rollup-planning',
        title: 'Rollup Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/rollup-planning/rollup-planning.component').then(
                m => m.RollupPlanningDashboardComponent
            ),
    },

    {
        path: 'dashboard/upselling',
        title: 'Upsell at Check-in',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/upselling/up-checkin/up-check-in.component').then(
                m => m.UpsellingCheckInComponent
            ),
    },
    {
        path: 'dashboard/upselling-brandweb',
        title: 'Brandweb Upsell',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/upselling/up-brandweb/up-brandweb.component').then(
                m => m.UpsellingBrandwebComponent
            ),
    },
    {
        path: 'dashboard/displacement-config',
        title: 'Displacement Config',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/displacement/displacement-config/displacement-config.component').then(
                m => m.DisplacementConfigComponent
            ),
    },
    {
        path: 'dashboard/one-pager',
        title: 'One Pager',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/score-cards/one-pager/one-pager.component').then(
                m => m.OnePagerComponent
            ),
    },

    {
        path: 'dashboard/rooms-planning',
        title: 'Rooms Planning',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/rooms-planning/rooms-planning.component').then(
                m => m.RoomsPlanningDashboardComponent
            ),
    },
    {
        path: 'dashboard/rooms-planning-admin',
        title: 'Market Code Mapping',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/market-code-mapping/market-code-mapping.component').then(
                m => m.MarketCodeMappingDashboardComponent
            ),
    },

    {
        path: 'dashboard/trx-code-mapping',
        title: 'Revenue Mapping',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/mapping/trx-code-mapping/trx-code-mapping.component').then(
                m => m.TrxCodeMappingDashboardComponent
            ),
    },

    {
        path: 'dashboard/outlet-calendar',
        title: 'Outlet Closure',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/outlet/outlet-closure/outlet-closure.component').then(
                m => m.OutletClosureDashboardComponent
            ),
    },

    {
        path: 'dashboard/bpc-planning-mapping',
        title: 'BPC Code Mapping',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/bpc-code-mapping/bpc-code-mapping.component').then(
                m => m.BpcCodeMappingDashboardComponent
            ),
    },
    {
        path: 'dashboard/forecasting-tool-lock-admin',
        title: 'Forecasting Tool Lock Admin',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/lock-admin/lock-admin.component').then(
                m => m.ForecastingToolLockAdminDashboardComponent
            ),
    },

    {
        path: 'dashboard/forecasting-tool-unlock-view',
        title: 'Forecasting Tool Unlock View',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/unlock-view/unlock-view.component').then(
                m => m.ForecastingToolUnlockViewDashboardComponent
            ),
    },
    {
        path: 'dashboard/forecasting-tool-calendar',
        title: 'Forecasting Tool Calendar',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/forecasting-tool/submission-calendar/submission-calendar.component').then(
                m => m.ForecastingToolSubmissionCalendarComponent
            ),
    },
    {
        path: 'dashboard/prod-sop',
        title: 'SOP - User Guide',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/productivity/prod-SOP/prod-SOP').then(
                m => m.ProdSOPComponent
            ),
    },
    {
        path: 'dashboard/gm-comments',
        title: 'GM Comments',
        loadComponent: (): any =>
            import('app/clients/rhg/dashboards/revops/gm-comments/gm-comments.component').then(
                m => m.GMCommentsComponent
            ),
    },
];
